import { ENV_CONFIG } from './env/config'

const HospitalListUrl = `${ENV_CONFIG.hospitalHost}/hospitals/list`

export { HospitalListUrl }
